/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_User_Groups_PromptInputs */

const en_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a user to manage groups`)
};

const fr_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un utilisateur pour gérer les groupes`)
};

const de_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Benutzer zur Verwaltung von Gruppen aus.`)
};

const it_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un utente per gestire i gruppi`)
};

const ru_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите пользователя для управления группами.`)
};

const es_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un usuario para administrar grupos`)
};

const zh_cn2_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要管理组的用户`)
};

const ja_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループを管理するユーザーを選択してください`)
};

const hi_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समूहों को प्रबंधित करने के लिए एक उपयोगकर्ता का चयन करें`)
};

const pt_pt2_team_manager_select_user_groups_prompt = /** @type {(inputs: Team_Manager_Select_User_Groups_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um usuário para gerenciar grupos.`)
};

/**
* | output |
* | --- |
* | "Select a user to manage groups" |
*
* @param {Team_Manager_Select_User_Groups_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_user_groups_prompt = /** @type {((inputs?: Team_Manager_Select_User_Groups_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_User_Groups_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_select_user_groups_prompt(inputs)
	if (locale === "de") return de_team_manager_select_user_groups_prompt(inputs)
	if (locale === "it") return it_team_manager_select_user_groups_prompt(inputs)
	if (locale === "ru") return ru_team_manager_select_user_groups_prompt(inputs)
	if (locale === "es") return es_team_manager_select_user_groups_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_select_user_groups_prompt(inputs)
	if (locale === "ja") return ja_team_manager_select_user_groups_prompt(inputs)
	if (locale === "hi") return hi_team_manager_select_user_groups_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_select_user_groups_prompt(inputs)
	return en_team_manager_select_user_groups_prompt(inputs)
});